import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { haveNextOfKinOptions } from '../utils';
// eslint-disable-next-line import/no-cycle
import NextOfKinDetails, { NextOfKinDetailsType } from './NextOfKinDetails';

interface NextOfKinProps {
  nextOfKinDetails: NextOfKinDetailsType;
  setNextOfKinDetails: React.Dispatch<
    React.SetStateAction<NextOfKinDetailsType>
  >;
}

const NextOfKin: React.FC<NextOfKinProps> = ({
  nextOfKinDetails,
  setNextOfKinDetails,
}) => {
  const nfkDetailsRef = useRef<HTMLDivElement | null>(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const scrollToId = (location.state as any)?.scrollTo;
    if (scrollToId) {
      setTimeout(() => {
        const el = document.getElementById(scrollToId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

        // Clear the scroll state to prevent it from running again
        navigate(location.pathname, { replace: true, state: {} });
      }, 50);
    }
  }, [location, navigate]);
  return (
    <div id="nfkDetails" ref={nfkDetailsRef}>
      <div className="govuk-form-group mt-5 govuk-bp:mt-6">
        <fieldset className="govuk-fieldset">
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--l">
            <h1 className="govuk-fieldset__heading">
              Do you have a Next of Kin?
            </h1>
          </legend>
          <div
            className="govuk-radios care-status__radios"
            data-module="govuk-radios"
          >
            {haveNextOfKinOptions.map(option => {
              return (
                <div className="govuk-radios__item" key={option.value}>
                  <input
                    className="govuk-radios__input"
                    id="next-of-kin-status"
                    name="haveNextOfKin"
                    type="radio"
                    value={option.value}
                    checked={nextOfKinDetails.nextOfKinStatus === option.value}
                    onChange={e =>
                      setNextOfKinDetails(prev => ({
                        ...prev,
                        nextOfKinStatus: e.target.value,
                      }))
                    }
                  />
                  <label
                    className="govuk-label govuk-radios__label"
                    htmlFor={option.value}
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
        </fieldset>
      </div>
      {nextOfKinDetails.nextOfKinStatus === 'yes' && (
        <NextOfKinDetails
          nextOfKinDetails={nextOfKinDetails}
          setNextOfKinDetails={setNextOfKinDetails}
        />
      )}
    </div>
  );
};

export default NextOfKin;
